import { useState, useEffect, useCallback, useMemo } from "react";

import { isNonEmpty, shallowCopy } from "_helpers";
import { saveSettings, getSettings } from "_services";

export function useSettings(){
    const initialValues = useMemo(() => ({
        periodicity: 'monthly',
        formats: ['report_pdf', 'report_xlsx', 'ci_pdf', 'ci_xlsx'],
        recipients: [],
        customReporting: []
    }), []);
    const [ values, setValues ] = useState(initialValues);
    const [ irrecCerts, setIrrecCerts ] = useState([]);
    const [ closedCerts, setClosedCerts ] = useState([]);
    const [ requestIsSubmitted, setRequestIsSubmitted ] = useState(false);

    const [ successMessage, setSuccessMessage ] = useState(null);
    const [ errorMessage, setErrorMessage ] = useState(null);

    const [ settingsDoRedirect, setSettingsDoRedirect ] = useState();

    useEffect(() => {
        doReload();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if( requestIsSubmitted ) doSave();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestIsSubmitted])

    const doSave = useCallback(() => {
        try{
            let valuesCopy = shallowCopy(values);
            valuesCopy['customReporting'] = valuesCopy['customReporting'].filter(el => {
                const { title, body } = el;
                if (title && body) {
                    const cleanedTitle = title.replace(/\s+/g, "");
                    return cleanedTitle !== "" && isNonEmpty(body);
                }
                return false;
            });
            valuesCopy['recipients'] = valuesCopy['recipients'].filter(el => {
                if( typeof el === "string" ) {
                    el = el.replace(/\s+/g, "");
                    return el !== "";
                }
                return false;
            });
            const timer = setTimeout(async () => {
                const { response, successMsg, errorMsg } = await saveSettings(valuesCopy);

                if( response ){
                    setSuccessMessage(successMsg);
                } else {
                    setErrorMessage(errorMsg);
                }
                // setDoRedirect(redirect);
            }, 0)

            return () => clearTimeout(timer);
        } catch(e){
            throw new Error(e);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values])

    const doReload = useCallback(() => {
        try{
            const timer = setTimeout(async () => {
                const { response, data, successMsg, errorMsg, redirect } = await getSettings();

                if( response ){
                    let config = shallowCopy(initialValues);
                    const dataConfig = data?.config || null,
                        ci = data?.ci || [],
                        clsd = data?.clsd || [];
                    if( dataConfig ){
                        for( const property in data.config ){
                            const value = data.config[property];
                            config[property] = value;
                        }
                    }
                    setValues(config);
                    setIrrecCerts(ci);
                    setClosedCerts(clsd);
                    setSuccessMessage(successMsg);
                } else {
                    setErrorMessage(errorMsg);
                }
                setSettingsDoRedirect(redirect);
            }, 0)

            return () => clearTimeout(timer);
        } catch(e){
            throw new Error(e);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return {
        valuesHandler: {
            values,
            setValues
        },
        irrecCerts,
        closedCerts,
        setRequestIsSubmitted,
        settingsDoRedirect,
        messageHandler: {
            successMessage,
            setSuccessMessage,
            errorMessage,
            setErrorMessage
        }
    }
}
